import axios from "axios";
import { baseUrl } from "../config/api-config";

const auth = (token) => ({ headers: { authorization: token } });

export function getDeadlines(token, params = {}) {
  return axios.get(`${baseUrl}/deadlines`, { ...auth(token), params });
}

export function getCaseDeadlines(token, caseId) {
  return axios.get(`${baseUrl}/case/${caseId}/deadlines`, auth(token));
}

export function addCaseDeadline(token, caseId, body) {
  return axios.post(`${baseUrl}/case/${caseId}/deadlines`, body, auth(token));
}

export function completeDeadline(token, id, body = {}) {
  return axios.post(`${baseUrl}/deadlines/${id}/complete`, body, auth(token));
}

export function extendDeadline(token, id, body) {
  return axios.post(`${baseUrl}/deadlines/${id}/extend`, body, auth(token));
}

export function getDeadlineAudit(token, id) {
  return axios.get(`${baseUrl}/deadlines/${id}/audit`, auth(token));
}

export function getDeadlineRules(token) {
  return axios.get(`${baseUrl}/deadline-rules`, auth(token));
}

export function createDeadlineRule(token, body) {
  return axios.post(`${baseUrl}/deadline-rules`, body, auth(token));
}

export function updateDeadlineRule(token, id, body) {
  return axios.patch(`${baseUrl}/deadline-rules/${id}`, body, auth(token));
}

export function getDeadlineHolidays(token) {
  return axios.get(`${baseUrl}/deadline-holidays`, auth(token));
}

export function addDeadlineHoliday(token, body) {
  return axios.post(`${baseUrl}/deadline-holidays`, body, auth(token));
}

export function deleteDeadlineHoliday(token, date) {
  return axios.delete(`${baseUrl}/deadline-holidays/${date}`, auth(token));
}

export function sweepDeadlinesDryRun(token) {
  return axios.post(`${baseUrl}/deadlines-sweep`, {}, { ...auth(token), params: { dryRun: true } });
}
